import { CardContent } from "@mui/material";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import ReactPlayer from "react-player";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import singleFrame from "../../../../Assets/Images/Normal-User/Single-frame.png";
import applePayLogo from "../../../../Assets/Images/Payment-img/Apple_Pay_logo.png";
import bKashLogo from "../../../../Assets/Images/Payment-img/BKash-bKash-Logo.wine.png";
import payoneerLogo from "../../../../Assets/Images/Payment-img/Payoneer-Logo.wine.png";
import payPalLogo from "../../../../Assets/Images/Payment-img/PayPal-Logo.wine.png";
import visaLogo from "../../../../Assets/Images/Payment-img/Visa_Inc._logo.svg.png";
import Navigation from "../../../Layouts/Header/Navigation";
import NoImage from "../../.../../../../Assets/Images/no-image.png";
import paytm from "../../../../Assets/Images/Payment-img/Paytm_Logo.png";

import "./AuditionWithStar.css";
import { usePaytm } from "../../../../CustomHooks/usePaytm";
import MyVerticallyCenteredModal from "../../../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";
import { serverInfo } from "../../../../App";
import { LocationContext } from "../../../../CustomHelper/Helper";
import { useZeroPayment } from "../../../../CustomHooks/useZeroPayment";
import {useI18n} from "../../../../i18n";


const AuditionWithStar = () => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  const params = useParams();
  const [modalShow, setModalShow] = React.useState(false);
  const [registered, setRegistured] = useState();
  const [isLoaded,setIsLoaded] = useState(false);
  const [event, setEvent] = React.useState({});
  const [passwordInput, setPassword] = useState("");

  const { slectedCurrency, payStatus } = useContext(LocationContext);
  const [countryBaseCost, setCountryBaseCost] = useState(false);

  const registerData = {
    quantity: 1,
    event_id: event?.id,
    event_registration_id:null,
    notification_id: null,
    model_name: "audition",
    fee: event?.fees,
    start_time: event?.start_time,
    end_time: event?.end_time,
    payment_method: "Free-Registaion",
  }
  const { freeRegistration, freeRegBuffer } = useZeroPayment(registerData)



  const handleInput = (e) => {
    e.persist();
    setPassword(e.target.value);
  };

  const { t } = useI18n();

  useEffect(() => {
    axios.get(`/api/user/audition/details/${params.slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.audition);
      }
    });
    axios
      .get(`api/user/registration_checker/audition/${params.slug}`)
      .then((res) => {
        if (res.data.status === 200) {
          setIsLoaded(true);
          setRegistured(res.data.participant);
        }
      });
  }, [params.slug]);

  useEffect(() => {
    setCountryBaseCost(
      (Number(event?.fees) * Number(slectedCurrency?.currency_value)).toFixed(0)
    );
  }, [event, slectedCurrency]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      password: passwordInput,
    };

    if (passwordInput) {
      axios.get("/sanctum/csrf-cookie").then((response) => {
        axios.post(`/api/verify_user`, data).then((res) => {
          if (res.data.status === 200) {
            if(event?.fees === 0){
              freeRegistration()
            }else{

              setModalShow(true);
            }
          } else {
            setPassword("");
            swal("Warning", res.data.message, "warning");
          }
        });
      });
    } else {
      swal("Warning", "Insert Password", "warning");
    }
  };


  return (
    <>
      <Navigation />

      <div className="container my-3">
        <div className="photoRelative w-100">
          <img
            src={imageCdnUrl + event.banner}
            className="img-fluid audioBanner my-3"
            alt=""
            style={{ width: "100%" }}
          />
          <h4 className="registrationDate text-white p-3 fw-bolder">
            {t('REGISTRATION_DATE_Text')}{" "}
            {moment(event.info?.registration_start_date).format("LL")} -
            {moment(event.info?.registration_end_date).format("LL")}
          </h4>
        </div>
        <div className="photoRelative">
          <ReactPlayer
            url={videoCdnUrl + event.video}
            // autoplay="false"
            playing="false"
            controls
            className="my-3 videoBanner"
            width="100%"
          />
          <p className="registrationDateVideo text-white p-3 fw-bolder">
            {t('REGISTRATION_DATE_Text')}{" "}
            {moment(event.info?.registration_start_date).format("LL")} -
            {moment(event.info?.registration_end_date).format("LL")}
          </p>
        </div>

        <div className="img-bg my-4 p-3 rounded-3">
          <p className="text-center withText fw-bold">
            <i>{t('With_Text')}: </i>{" "}
          </p>
          <div className="d-flex justify-content-center">
            {event?.assigned_judges?.map((judge) => (
              <img
                src={judge.user?.image?imageCdnUrl + judge.user?.image:NoImage}
                alt=""
                className="imageWidth img-fluid"
              />
            ))}

            {/* <img src={fourthIMage} className="imageWidthTwo" alt="" />
              <img src={fourthIMage} className="imageWidth" alt="" />
              <img src={fourthIMage} className="imageWidthTwo" alt="" /> */}
          </div>
        </div>


     { registered ? (
          <div className="guitarBorder">
            <div className="p-5 m-3">
              <div className="mt-4 pt-3">
                <div className="text-center mt-4">
                  <button className="btn registerBtn mt-3">
                    {t('Already_Registered_at_Text')}{" "}
                    {moment(registered.created_at).format("LL")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (

          isLoaded && ( <div className="guitarBorder">
          <div className="p-5 m-3">
            <h3 className="text-warning">{event.title}</h3>
            <div className="guitarBorderGold my-3"></div>

            <div className="row">
              <div className="col-md-6 mt-3">
                <div className="d-flex">
                  <div className="text-light listStyle">
                    <li className="fw-bold">{t('Start_Text')}</li>
                    <li className="fw-bold">{t('End_Text')}</li>
                    <li className="fw-bold">{t('Fee_Text')}</li>
                  </div>
                  <div className="text-light listStyle ms-5">
                    <li> {moment(event.start_date).format("LL")}</li>
                    <li> {moment(event.end_date).format("LL")}</li>
                    <li>{countryBaseCost + " " + slectedCurrency?.symbol}</li>
                  </div>
                </div>
              </div>
              <div className="col-md-6 text-light mt-3">
                <h5>{t('Instruction_Text')}</h5>
                <p>
                  <Markup content={event.instruction} />
                </p>
              </div>
            </div>

            <div className="mt-4 pt-3">
              <div className="row my-3">
                <div className="col-md-6">
                  <h5 className="text-light fw-bold">{t('Participant_name_Text')}</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_name")||''}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <h5 className="text-light fw-bold">{t('Phone_number_Text')}</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_phone")||''}
                    readOnly
                  />
                </div>
              </div>

              <div className="row my-3">
                <div className="col-md-6">
                  <h5 className="text-light fw-bold">{t('Email_Text')}</h5>
                  <input
                    type="text"
                    className="form-control inputColorBorder text-light"
                    value={localStorage.getItem("auth_email")||''}
                    readOnly
                  />
                </div>
                <div className="col-md-6">
                  <h5 className="text-light fw-bold">{t('Password_Text')}</h5>
                  <input
                    type="password"
                    className="form-control inputColorBorder text-light"
                    name="password"
                    value={passwordInput}
                    onChange={handleInput}
                    required
                  />
                </div>
              </div>
              {countryBaseCost && (
                <div className="row mt-4">
                  {payStatus && (
                    <div className="col-md-3 mx-auto">
                      <button
                        onClick={handleSubmit}
                        className="btn registerBtn w-100 fw-bold"
                      >
                        {t('Register_Text')}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )
         ) }



        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          event_id={event?.id}
          baseFee={countryBaseCost}
          fee={countryBaseCost}
          event_type="audition"
          redirectTo="enrolled-auditions"
        />
      </div>
    </>
  );
};

export default AuditionWithStar;
